export default __webpack_public_path__ + "static/media/A002samah.09c7a045.jpg";